import { variantToArtnr } from "$utils/variant-to-artnr";
import { TYPE_KVM, TYPE_METER } from "../../constants";
import type { CartProduct } from "../../stores/cart";

export function variantToMetaAdsProductId(variant: CartProduct) {
    if ("artnr" in variant) {
        return variant.artnr;
    }
    if ([TYPE_METER, TYPE_KVM].includes(variant.type)) {
        return `${variant.id}-${variant.color.id}`;
    }
    return variantToArtnr(variant);
}
